export default "__VITE_ASSET__dgkrvRwm__"